import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(() => ({}), { index: 1 })

export { useStyles }
